import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, isRef as _isRef, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, Suspense as _Suspense, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64676d04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel" }
const _hoisted_2 = { class: "filter-item" }
const _hoisted_3 = { class: "filter-item" }
const _hoisted_4 = { class: "filter-item" }
const _hoisted_5 = { class: "addNewBtn" }
const _hoisted_6 = {
  class: "panel",
  style: {"min-height":"70vh"}
}
const _hoisted_7 = { class: "tabs-list flex" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "rel" }
const _hoisted_10 = {
  key: 0,
  class: "abs badge"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["href"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["href"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "~", -1))
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  key: 0,
  class: "flex-wrap row-btns mt_5"
}
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { class: "title-2" }
const _hoisted_24 = {
  class: "flex-cen pt_10",
  style: {"height":"520px","overflow":"auto","padding":"20px"}
}
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "title-3 text-rt" }

import Filter from './Filter.vue'
import { ref, reactive, watch, computed, nextTick } from 'vue'
import { useStore } from 'vuex'
import { t } from '@/plugins/i18n'
import { useRouter } from 'vue-router'
import { isJA, useRtfix, useSite } from '@/store'
import STable from '@/components/Table/index.vue'
import Form from './Form.vue'
import CheckLog from './CheckLog.vue'
import { ElMessageBox } from 'element-plus'
import {
  brandAuthStatistic,
  brandAuthListPage,
  brandAuthCancel,
  brandAuthSubmit
} from '@/apis/brand'
import { download } from '@/util/useSave'
import { removeTime } from '../components/suffix'
import { checkMember } from '@/views/goods/components/brandAuth'

enum Status {
  /** 全部 */
  ALL = ' ',
  /** 待提交 */
  S1 = 'WAIT',
  /** 审核中 */
  S2 = 'AUDIT',
  /** 已授权 */
  S3 = 'SUCCESS',
  /** 已取消 */
  S4 = 'CANCEL',
  /** 已拒绝 */
  S5 = 'REJECT',
  /** 已失效 */
  S6 = 'OVERDUE',
}

type Row = any

// 弹窗
enum Modal {
  /** 申请信息 */
  M1 = 1,
  /** 审核信息 */
  M2 = 2,
  /** 查看授权书 */
  M3 = 3,
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const router = useRouter()
const membership = computed(() => store.getters.membership)
// 状态
const status = [
  ['全部_', Status.ALL, 'totalCount'],
  ['待提交', Status.S1, 'waitCount'],
  ['审核中', Status.S2, 'auditCount'],
  ['已授权3', Status.S3, 'successCount'],
  ['已取消1', Status.S4, 'cancelCount'],
  ['已拒绝4', Status.S5, 'rejectCount'],
  ['已失效_', Status.S6, 'overdueCount']
] as const

const statData = reactive<Record<Status, number>>({} as any)

const statist = () => {
  brandAuthStatistic().setSite((res) => {
    if (res.success) {
      status.forEach(([label, key, key2]) => {
        statData[key] = res.data[key2]
      })
    }
  })
}
statist()

// 筛选
const useReset = function <T>(resetData: T) {
  const cur = ref(resetData)
  const reset = () => {
    cur.value = JSON.parse(JSON.stringify(resetData))
  }
  reset()
  return [cur, reset] as const
}

const authTypeText = ['普通授权', '独家授权'].map((v) => t(v))

const authTypes = [
  { label: t('全部_'), value: '' },
  ...authTypeText.map((v, i) => ({ label: v, value: i }))
]

const [filter, reset] = useReset({
  // 该字段表示需要把表格数据格式化时间和文案
  _setSite: true,
  brandName: '',
  brandAuthType: '',
  applyStartTime: '',
  applyEndTime: '',
  applyStatus: Status.ALL
})

const applyTime = computed({
  get: () => [filter.value.applyStartTime, filter.value.applyEndTime],
  set: (newVal) => {
    [filter.value.applyStartTime, filter.value.applyEndTime] = newVal ?? []
  }
})

// 表格查询
const STableRef = ref()

const query = () => {
  console.log('query')
  nextTick(STableRef.value.getData)
}

// 表格配置
const tableConfig = {
  showHandler: true,
  setHeight: true,
  rowKey: 'applyId',
  handlerConfig: { label: t('操作'), width: 280 },
  height: 600
}

const pageData = ref({
  page: 1,
  limit: 10
})

const columns = computed(() => {
  let newColumns = [
    {
      label: t('序号'),
      prop: 'index',
      formatter: (...r: any[]) => {
        return r[3] + 1
      }
    },
    {
      label: t('品牌图片'),
      prop: 'mainImgUrl'
    },
    {
      label: t('品牌信息'),
      prop: 'brandName'
    },
    {
      label: t('品牌国家'),
      prop: 'country'
    },
    {
      label: t('申请类型'),
      prop: 'brandAuthType',
      formatter: (...r: any[]) => {
        return authTypeText[r[2]]
      }
    },
    {
      label: t('申请信息'),
      prop: 'applyInfo'
    },
    {
      label: t('审核信息'),
      prop: 'auditInfo'
    },
    // {
    //   label: t('授权状态1'),
    //   prop: 'applyStatus',
    //   formatter: (...r: any[]) => {
    //     console.log(r)
    //     const text = status.find((v) => v[1] === r[2])?.[0] ?? ''
    //     return t(text)
    //   }
    // },
    {
      label: t('申请日期'),
      prop: 'applyTime',
      formatter: (...r: any[]) => {
        return r[2] ?? '-'
      },
      width: '110px'
    },
    {
      label: t('店铺URL'),
      prop: 'brandShopUrlList',
      width: '150px'
    },
    {
      label: t('授权有效期'),
      prop: 'authEndTime',
      width: '110px'
    }
  ]
  //   如果不是日本站，隐藏品牌国家
  if (!isJA()) {
    newColumns = newColumns.filter((item) => item.prop !== 'country')
  }
  return newColumns.map((v) => ({
    ...v,
    align: 'center',
    slotName: v.formatter ? undefined : v.prop
  }))
})

const visible = ref(false)

const curRow = ref()

const curM = ref()

const modals = {
  [Modal.M1]: '6vh',
  [Modal.M2]: '24vh',
  [Modal.M3]: '20vh'
} as const

const open = (row: Row, m: Modal) => {
  visible.value = true
  curRow.value = row
  curM.value = m
}

const confirm = (msg: string, fn: () => void) => {
  return ElMessageBox.confirm(msg, t('提示'), {
    confirmButtonText: t('确定'),
    cancelButtonText: t('取消')
  })
    .catch(() => false)
    .then((res) => res && fn())
}

// 操作
const edit = (row: Row) => {
  // 独家授权校验会员等级
  if (!checkMember(row?.customerAuthTypeList?.every((v:number) => v === 1), store, router)) return
  router.push(useRtfix('BrandAuth', { query: { id: row.applyId } }))
}

const publish = ({ applyId, customerAuthTypeList }: Row) => {
  // 独家授权校验会员等级
  if (!checkMember(customerAuthTypeList?.every((v:number) => v === 1), store, router)) return
  confirm(t('是否确认提交？'), () => {
    brandAuthSubmit({ applyId }).then((res) => {
      console.log(res)
      query()
      statist()
    })
  })
}
const againSubmit = (row: Row) => {
  // 独家授权校验会员等级
  if (!checkMember(row.customerAuthTypeList?.every((v:number) => v === 1), store, router)) return
  router.push(
    useRtfix('BrandAuth', { query: { id: row.applyId } })
  )
}

const del = ({ applyId }: Row) => {
  confirm(t('是否确认取消？'), () => {
    brandAuthCancel({ applyId }).then((res) => {
      console.log(res)
      query()
      statist()
    })
  })
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_table_button = _resolveComponent("table-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Filter, {
        onQuery: query,
        onReset: _unref(reset)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("label", null, _toDisplayString(_unref(t)('品牌名称')), 1),
            _createVNode(_component_el_input, {
              modelValue: _unref(filter).brandName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filter).brandName) = $event)),
              onKeyup: _withKeys(query, ["enter"])
            }, null, 8, ["modelValue", "onKeyup"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", null, _toDisplayString(_unref(t)('申请类型')), 1),
            _createVNode(_component_el_select, {
              modelValue: _unref(filter).brandAuthType,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(filter).brandAuthType) = $event)),
              onChange: query
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(authTypes, (v) => {
                  return _createVNode(_component_el_option, {
                    key: v.label,
                    label: v.label,
                    value: v.value
                  }, null, 8, ["label", "value"])
                }), 64))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", null, _toDisplayString(_unref(t)('申请日期')), 1),
            _createVNode(_component_el_date_picker, {
              modelValue: _unref(applyTime),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(applyTime) ? (applyTime).value = $event : null)),
              type: "daterange",
              "range-separator": "-",
              "start-placeholder": _unref(t)('开始日期'),
              "end-placeholder": _unref(t)('结束日期1'),
              format: "YYYY-MM-DD",
              "value-format": "YYYY-MM-DD",
              style: {"width":"260px"},
              onChange: query
            }, null, 8, ["modelValue", "start-placeholder", "end-placeholder"])
          ])
        ]),
        _: 1
      }, 8, ["onReset"]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push(_unref(useRtfix)('BrandList'))))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('新增品牌授权')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(status), (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item[0],
            class: _normalizeClass(["demo-tabs", { active: item[1] === _unref(filter).applyStatus }]),
            onClick: ($event: any) => {_unref(filter).applyStatus = item[1]; query()}
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)(item[0])), 1),
              (_unref(statData)[item[1]] > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(statData)[item[1]]), 1))
                : _createCommentVNode("", true)
            ])
          ], 10, _hoisted_8))
        }), 128))
      ]),
      _createVNode(STable, {
        ref: (_value, _refs) => {
          _refs['STableRef'] = _value
          STableRef.value = _value
        },
        "page-data": pageData.value,
        "onUpdate:page-data": _cache[4] || (_cache[4] = ($event: any) => ((pageData).value = $event)),
        columns: _unref(columns),
        filterData: _unref(filter),
        api: _unref(brandAuthListPage),
        "table-config": tableConfig
      }, {
        mainImgUrl: _withCtx(({ row }) => [
          _createElementVNode("div", null, [
            _createVNode(_component_el_image, {
              src: row.mainImgUrl
            }, null, 8, ["src"])
          ])
        ]),
        brandName: _withCtx(({ row }) => [
          _createElementVNode("div", null, [
            (row.invalidBrand)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (!_unref(isJA)())
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: _unref(useRtfix)('BrandDetail', {
              params: { brand: row.brandId ?? 'notmatch' },
            })
              
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(row.brandName), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: `/choice/brand/${row.brandCode}`
                      }, _toDisplayString(row.brandName), 9, _hoisted_12))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createTextVNode(_toDisplayString(row.brandName) + " ", 1),
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_tag, {
                      class: "ml_2",
                      type: "danger"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('品牌已下架')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]))
          ])
        ]),
        brandShopUrlList: _withCtx(({ row }) => [
          (row.brandShopUrlList)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(row.brandShopUrlList, (v) => {
                return (_openBlock(), _createElementBlock("div", { key: v }, [
                  (v && !v?.includes('yishouapp'))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: v,
                        target: "_blank"
                      }, _toDisplayString(v), 9, _hoisted_14))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            : _createCommentVNode("", true)
        ]),
        country: _withCtx(({ row }) => [
          _createElementVNode("div", null, _toDisplayString(_unref(t)(row.country)), 1)
        ]),
        applyInfo: _withCtx(({ row }) => [
          (row.applyStatus !== Status.S1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "cursor-pt",
                onClick: ($event: any) => (open(row, Modal.M1))
              }, _toDisplayString(_unref(t)('查看详情')), 9, _hoisted_15))
            : (_openBlock(), _createElementBlock("div", _hoisted_16, "-"))
        ]),
        auditInfo: _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(_unref(t)(_unref(status).find((v) => v[1] === row.applyStatus)?.[0] ?? '')) + " ", 1),
          ([Status.S2, Status.S3, Status.S5, Status.S6].includes(row.applyStatus))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "cursor-pt",
                onClick: ($event: any) => (open(row, Modal.M2))
              }, _toDisplayString(_unref(t)('查看详情')), 9, _hoisted_17))
            : _createCommentVNode("", true)
        ]),
        authEndTime: _withCtx(({ row }) => [
          (row.authEndTime)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", null, _toDisplayString(_unref(removeTime)(row.authStartTime)), 1),
                _hoisted_19,
                _createElementVNode("div", null, _toDisplayString(_unref(removeTime)(row.authEndTime)), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_20, "-"))
        ]),
        handler: _withCtx(({ scope }) => [
          (scope.row.invalidBrand)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                ([Status.S1].includes(scope.row.applyStatus))
                  ? (_openBlock(), _createBlock(_component_table_button, {
                      key: 0,
                      title: _unref(t)('编辑'),
                      onClick: ($event: any) => (edit(scope.row)),
                      class: _normalizeClass(["rel", (_unref(membership)?.templateLevel === 0 ? 'member_long' : '') + ' ' + _unref(useSite)() ])
                    }, null, 8, ["title", "onClick", "class"]))
                  : _createCommentVNode("", true),
                ([Status.S1].includes(scope.row.applyStatus))
                  ? (_openBlock(), _createBlock(_component_table_button, {
                      key: 1,
                      title: _unref(t)('提交_'),
                      onClick: ($event: any) => (publish(scope.row)),
                      class: _normalizeClass(["rel", (_unref(membership)?.templateLevel === 0 ? 'member_long' : '') + ' ' + _unref(useSite)() ])
                    }, null, 8, ["title", "onClick", "class"]))
                  : _createCommentVNode("", true),
                ([Status.S1].includes(scope.row.applyStatus))
                  ? (_openBlock(), _createBlock(_component_table_button, {
                      key: 2,
                      title: _unref(t)('取消'),
                      onClick: ($event: any) => (del(scope.row))
                    }, null, 8, ["title", "onClick"]))
                  : _createCommentVNode("", true),
                ([Status.S3].includes(scope.row.applyStatus))
                  ? _withDirectives((_openBlock(), _createBlock(_component_table_button, {
                      key: 3,
                      title: _unref(t)('下载授权书'),
                      onClick: ($event: any) => (open(scope.row, Modal.M3))
                    }, null, 8, ["title", "onClick"])), [
                      [_vShow, scope.row.authUrl]
                    ])
                  : _createCommentVNode("", true),
                ([Status.S6].includes(scope.row.applyStatus))
                  ? (_openBlock(), _createBlock(_component_table_button, {
                      key: 4,
                      title: _unref(t)('重新申请'),
                      onClick: ($event: any) => (againSubmit(scope.row)),
                      class: _normalizeClass(["rel", (_unref(membership)?.templateLevel === 0 ? 'member_long' : '') + ' ' + _unref(useSite)() ])
                    }, null, 8, ["title", "onClick", "class"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["page-data", "columns", "filterData", "api"]),
      _createVNode(_component_el_dialog, {
        modelValue: visible.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((visible).value = $event)),
        "destroy-on-close": "",
        width: 650,
        "append-to-body": "",
        "modal-class": "brand-modal",
        top: _unref(modals)[curM.value as Modal]
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_Suspense, null, {
            default: _withCtx(() => [
              (curM.value === Modal.M1)
                ? (_openBlock(), _createBlock(Form, {
                    key: 0,
                    id: curRow.value.applyId,
                    width: 650,
                    close: () => (visible.value = false)
                  }, null, 8, ["id", "close"]))
                : (curM.value === Modal.M2)
                  ? (_openBlock(), _createBlock(CheckLog, {
                      key: 1,
                      id: curRow.value.applyId,
                      close: () => (visible.value = false)
                    }, null, 8, ["id", "close"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(t)('品牌授权书')), 1),
                      _createElementVNode("div", _hoisted_24, [
                        (curRow.value.authUrl.toLowerCase().includes('.pdf'))
                          ? (_openBlock(), _createElementBlock("iframe", {
                              key: 0,
                              src: curRow.value.authUrl,
                              frameborder: "0",
                              width: "472",
                              height: "472"
                            }, null, 8, _hoisted_25))
                          : (_openBlock(), _createBlock(_component_el_image, {
                              key: 1,
                              src: curRow.value.authUrl,
                              alt: ""
                            }, null, 8, ["src"]))
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          size: "large",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(download)(curRow.value.authUrl, curRow.value.brandName)))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('下载')), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]))
            ]),
            _: 1
          }))
        ]),
        _: 1
      }, 8, ["modelValue", "top"])
    ])
  ], 64))
}
}

})